module.exports = __webpack_public_path__ + "img/zu 389.131b47a0.png";